import { inject } from "aurelia-framework";
import { NavigationInstruction } from "aurelia-router";
import { AuthService } from "./auth-service";

@inject(AuthService)
export class AuthFilterValueConverter {
  constructor(private authService: AuthService) {}

  toView(routes: Array<NavigationInstruction>) {
    return routes.filter((n) => {
      let isVisible = !this.isHidden(n);
      return (
        isVisible &&
        (!this.needsAuthentication(n) ||
          (this.isAuthenticated() && this.hasMatchingRights(n)))
      );
    });
  }

  private isHidden(n: NavigationInstruction): boolean {
    return n.config.settings && !!n.config.settings.hidden;
  }

  private needsAuthentication(n: NavigationInstruction): boolean {
    return (
      n.config.settings &&
      (n.config.settings.auth || n.config.settings.needsRightOneOf)
    );
  }

  private isAuthenticated(): boolean {
    return this.authService.isAuthenticated();
  }

  private hasMatchingRights(n: NavigationInstruction): boolean {
    return (
      !n.config.settings.needsRightOneOf ||
      this.authService.hasRightOneOf(n.config.settings.needsRightOneOf)
    );
  }
}
